import { fetchLocalizations } from "./localizationActions";
import * as notificationsActions from "./notificationsActions";
import * as searchActions from "./searchActions";
import * as settingsActions from "./settingsActions";

export default (store) => ({
    fetchLocalizations: (state) => fetchLocalizations(store),

    initEventNotifications: (state) =>
        notificationsActions.initEventNotifications(store),
    subscribeToEvents: (state, eventIds) =>
        notificationsActions.subscribeToEvent(store, eventIds),
    unsubscribeToEvents: (state, eventIds) =>
        notificationsActions.unsubscribeToEvent(store, eventIds),

    search: (state, eventIds) => searchActions.search(store, eventIds),
    close: (state) => searchActions.close(store),
    openCloseListener: (state) => searchActions.openCloseListener(store),

    saveNotificationSoundOn: (state, actualValue) =>
        settingsActions.saveNotificationSoundOn(store, actualValue),
    saveSettings:(state, actualSettings) =>
        settingsActions.saveSettings(store, actualSettings),
    updateSettingsFromStorage: (state) =>
        settingsActions.updateSettingsFromStorage(store),
});
